var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveBetterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1416.65,
    height: 371.048,
    viewBox: "0 0 1416.65 371.048",
    fill: "none",
    id: "svg228",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 166.801,371.048 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint0_linear_61_500)",
    id: "path1",
    style: {
      fill: "url(#paint0_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 234.883,371.048 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint1_linear_61_500)",
    id: "path2",
    style: {
      fill: "url(#paint1_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.719,337.007 H 68.082 V 306.37 h 30.637 z",
    fill: "url(#paint2_linear_61_500)",
    id: "path3",
    style: {
      fill: "url(#paint2_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200.842,337.007 H 170.205 V 306.37 h 30.637 z",
    fill: "url(#paint3_linear_61_500)",
    id: "path4",
    style: {
      fill: "url(#paint3_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 302.966,337.007 H 272.329 V 306.37 h 30.637 z",
    fill: "url(#paint4_linear_61_500)",
    id: "path5",
    style: {
      fill: "url(#paint4_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.678,302.966 H 34.041 v -30.637 h 30.637 z",
    fill: "url(#paint5_linear_61_500)",
    id: "path6",
    style: {
      fill: "url(#paint5_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.76,302.966 H 102.123 V 272.329 H 132.76 Z",
    fill: "url(#paint6_linear_61_500)",
    id: "path7",
    style: {
      fill: "url(#paint6_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 166.801,302.966 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint7_linear_61_500)",
    id: "path8",
    style: {
      fill: "url(#paint7_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200.842,302.966 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint8_linear_61_500)",
    id: "path9",
    style: {
      fill: "url(#paint8_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 234.883,302.966 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint9_linear_61_500)",
    id: "path10",
    style: {
      fill: "url(#paint9_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 268.924,302.966 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint10_linear_61_500)",
    id: "path11",
    style: {
      fill: "url(#paint10_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 337.007,302.966 H 306.37 v -30.637 h 30.637 z",
    fill: "url(#paint11_linear_61_500)",
    id: "path12",
    style: {
      fill: "url(#paint11_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.719,268.924 H 68.082 v -30.637 h 30.637 z",
    fill: "url(#paint12_linear_61_500)",
    id: "path13",
    style: {
      fill: "url(#paint12_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200.842,268.924 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint13_linear_61_500)",
    id: "path14",
    style: {
      fill: "url(#paint13_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 302.966,268.924 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint14_linear_61_500)",
    id: "path15",
    style: {
      fill: "url(#paint14_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.637,234.883 H 0 v -30.637 h 30.637 z",
    fill: "url(#paint15_linear_61_500)",
    id: "path16",
    style: {
      fill: "url(#paint15_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.678,234.883 H 34.041 v -30.637 h 30.637 z",
    fill: "url(#paint16_linear_61_500)",
    id: "path17",
    style: {
      fill: "url(#paint16_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.719,234.883 H 68.082 v -30.637 h 30.637 z",
    fill: "url(#paint17_linear_61_500)",
    id: "path18",
    style: {
      fill: "url(#paint17_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 200.842,234.883 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint18_linear_61_500)",
    id: "path19",
    style: {
      fill: "url(#paint18_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 337.007,234.883 H 306.37 v -30.637 h 30.637 z",
    fill: "url(#paint19_linear_61_500)",
    id: "path20",
    style: {
      fill: "url(#paint19_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 371.048,234.883 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint20_linear_61_500)",
    id: "path21",
    style: {
      fill: "url(#paint20_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.719,200.842 H 68.082 v -30.637 h 30.637 z",
    fill: "url(#paint21_linear_61_500)",
    id: "path22",
    style: {
      fill: "url(#paint21_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 302.966,200.842 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint22_linear_61_500)",
    id: "path23",
    style: {
      fill: "url(#paint22_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.637,166.801 H 0 v -30.637 h 30.637 z",
    fill: "url(#paint23_linear_61_500)",
    id: "path24",
    style: {
      fill: "url(#paint23_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.678,166.801 H 34.041 v -30.637 h 30.637 z",
    fill: "url(#paint24_linear_61_500)",
    id: "path25",
    style: {
      fill: "url(#paint24_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.719,166.801 H 68.082 v -30.637 h 30.637 z",
    fill: "url(#paint25_linear_61_500)",
    id: "path26",
    style: {
      fill: "url(#paint25_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 337.007,166.801 H 306.37 v -30.637 h 30.637 z",
    fill: "url(#paint26_linear_61_500)",
    id: "path27",
    style: {
      fill: "url(#paint26_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 371.048,166.801 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint27_linear_61_500)",
    id: "path28",
    style: {
      fill: "url(#paint27_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.719,132.76 H 68.082 v -30.637 h 30.637 z",
    fill: "url(#paint28_linear_61_500)",
    id: "path29",
    style: {
      fill: "url(#paint28_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.76,132.76 H 102.123 V 102.123 H 132.76 Z",
    fill: "url(#paint29_linear_61_500)",
    id: "path30",
    style: {
      fill: "url(#paint29_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 268.924,132.76 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint30_linear_61_500)",
    id: "path31",
    style: {
      fill: "url(#paint30_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 302.966,132.76 h -30.637 v -30.637 h 30.637 z",
    fill: "url(#paint31_linear_61_500)",
    id: "path32",
    style: {
      fill: "url(#paint31_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.678,98.719 H 34.041 V 68.082 h 30.637 z",
    fill: "url(#paint32_linear_61_500)",
    id: "path33",
    style: {
      fill: "url(#paint32_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.76,98.719 H 102.123 V 68.082 h 30.637 z",
    fill: "url(#paint33_linear_61_500)",
    id: "path34",
    style: {
      fill: "url(#paint33_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 166.801,98.719 H 136.164 V 68.082 h 30.637 z",
    fill: "url(#paint34_linear_61_500)",
    id: "path35",
    style: {
      fill: "url(#paint34_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 234.883,98.719 H 204.246 V 68.082 h 30.637 z",
    fill: "url(#paint35_linear_61_500)",
    id: "path36",
    style: {
      fill: "url(#paint35_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 268.924,98.719 H 238.287 V 68.082 h 30.637 z",
    fill: "url(#paint36_linear_61_500)",
    id: "path37",
    style: {
      fill: "url(#paint36_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 337.007,98.719 H 306.37 V 68.082 h 30.637 z",
    fill: "url(#paint37_linear_61_500)",
    id: "path38",
    style: {
      fill: "url(#paint37_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.719,64.678 H 68.082 V 34.041 h 30.637 z",
    fill: "url(#paint38_linear_61_500)",
    id: "path39",
    style: {
      fill: "url(#paint38_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.76,64.678 H 102.123 V 34.041 h 30.637 z",
    fill: "url(#paint39_linear_61_500)",
    id: "path40",
    style: {
      fill: "url(#paint39_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200.842,64.678 H 170.205 V 34.041 h 30.637 z",
    fill: "url(#paint40_linear_61_500)",
    id: "path41",
    style: {
      fill: "url(#paint40_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 302.966,64.678 H 272.329 V 34.041 h 30.637 z",
    fill: "url(#paint41_linear_61_500)",
    id: "path42",
    style: {
      fill: "url(#paint41_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 166.801,30.637 H 136.164 V 0 h 30.637 z",
    fill: "url(#paint42_linear_61_500)",
    id: "path43",
    style: {
      fill: "url(#paint42_linear_61_500)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 234.883,30.637 H 204.246 V 0 h 30.637 z",
    fill: "url(#paint43_linear_61_500)",
    id: "path44",
    style: {
      fill: "url(#paint43_linear_61_500)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1357.11,263.251 V 152.958 h 19 v 26.757 l -2.66,-3.472 c 1.36,-3.541 3.13,-6.775 5.31,-9.702 2.18,-2.996 4.7,-5.447 7.56,-7.353 2.79,-2.043 5.89,-3.608 9.29,-4.698 3.47,-1.157 7.01,-1.838 10.62,-2.042 3.61,-0.273 7.08,-0.102 10.42,0.51 v 20.017 c -3.61,-0.954 -7.63,-1.226 -12.05,-0.817 -4.36,0.408 -8.38,1.804 -12.05,4.187 -3.47,2.246 -6.23,4.97 -8.27,8.169 -1.98,3.2 -3.41,6.775 -4.29,10.723 -0.89,3.881 -1.33,8 -1.33,12.357 v 55.657 z",
    fill: "#d82d4f",
    id: "path45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 1284.16,266.315 c -10.96,0 -20.6,-2.383 -28.9,-7.148 -8.24,-4.834 -14.67,-11.54 -19.3,-20.119 -4.57,-8.646 -6.85,-18.654 -6.85,-30.024 0,-12.05 2.25,-22.501 6.74,-31.352 4.57,-8.85 10.9,-15.693 19,-20.527 8.1,-4.833 17.53,-7.25 28.29,-7.25 11.23,0 20.8,2.621 28.69,7.863 7.9,5.174 13.79,12.561 17.67,22.161 3.95,9.6 5.52,21.003 4.7,34.211 h -21.35 v -7.761 c -0.13,-12.8 -2.58,-22.263 -7.35,-28.39 -4.7,-6.128 -11.88,-9.191 -21.55,-9.191 -10.68,0 -18.72,3.37 -24.1,10.11 -5.38,6.74 -8.06,16.476 -8.06,29.207 0,12.119 2.68,21.514 8.06,28.186 5.38,6.604 13.14,9.906 23.29,9.906 6.67,0 12.42,-1.498 17.26,-4.494 4.9,-3.063 8.71,-7.42 11.43,-13.071 l 20.94,6.638 c -4.29,9.872 -10.79,17.531 -19.51,22.977 -8.71,5.379 -18.41,8.068 -29.1,8.068 z m -39.32,-52.185 v -16.646 h 78.74 v 16.646 z",
    fill: "#d82d4f",
    id: "path46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 1138.19,263.252 c -6.95,1.361 -13.75,1.94 -20.43,1.736 -6.67,-0.205 -12.63,-1.498 -17.87,-3.881 -5.24,-2.383 -9.19,-6.127 -11.84,-11.234 -2.39,-4.561 -3.68,-9.191 -3.89,-13.888 -0.13,-4.766 -0.2,-10.145 -0.2,-16.136 v -97.528 h 21.45 v 96.507 c 0,4.425 0.03,8.272 0.1,11.54 0.13,3.268 0.85,6.025 2.14,8.272 2.45,4.221 6.33,6.638 11.64,7.251 5.38,0.544 11.68,0.306 18.9,-0.715 z m -75.37,-93.137 v -17.157 h 75.37 v 17.157 z m 149.41,93.137 c -6.95,1.361 -13.76,1.94 -20.43,1.736 -6.67,-0.205 -12.63,-1.498 -17.87,-3.881 -5.24,-2.383 -9.19,-6.127 -11.85,-11.234 -2.38,-4.561 -3.67,-9.191 -3.88,-13.888 -0.13,-4.766 -0.2,-10.145 -0.2,-16.136 v -97.528 h 21.45 v 96.507 c 0,4.425 0.03,8.272 0.1,11.54 0.13,3.268 0.85,6.025 2.14,8.272 2.45,4.221 6.33,6.638 11.64,7.251 5.38,0.544 11.68,0.306 18.9,-0.715 z m -75.37,-93.137 v -17.157 h 75.37 v 17.157 z",
    fill: "#d82d4f",
    id: "path47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 1002.12,266.315 c -10.96,0 -20.59,-2.383 -28.9,-7.148 -8.24,-4.834 -14.67,-11.54 -19.3,-20.119 -4.56,-8.646 -6.84,-18.654 -6.84,-30.024 0,-12.05 2.25,-22.501 6.74,-31.352 4.56,-8.85 10.89,-15.693 18.99,-20.527 8.11,-4.833 17.53,-7.25 28.29,-7.25 11.24,0 20.8,2.621 28.7,7.863 7.9,5.174 13.78,12.561 17.67,22.161 3.94,9.6 5.51,21.003 4.69,34.211 h -21.34 v -7.761 c -0.14,-12.8 -2.59,-22.263 -7.35,-28.39 -4.7,-6.128 -11.88,-9.191 -21.55,-9.191 -10.69,0 -18.72,3.37 -24.1,10.11 -5.38,6.74 -8.07,16.476 -8.07,29.207 0,12.119 2.69,21.514 8.07,28.186 5.38,6.604 13.14,9.906 23.28,9.906 6.67,0 12.43,-1.498 17.26,-4.494 4.9,-3.063 8.71,-7.42 11.44,-13.071 l 20.93,6.638 c -4.29,9.872 -10.79,17.531 -19.5,22.977 -8.72,5.379 -18.42,8.068 -29.11,8.068 z M 962.81,214.13 v -16.646 h 78.73 v 16.646 z",
    fill: "#d82d4f",
    id: "path48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 825.55,263.252 V 116.194 h 57.8 c 9.33,0 17.16,1.906 23.49,5.719 6.33,3.813 11.1,8.749 14.3,14.808 3.2,5.991 4.8,12.323 4.8,18.995 0,8.102 -2.01,15.046 -6.03,20.833 -3.95,5.787 -9.29,9.736 -16.03,11.846 l -0.2,-5.004 c 9.39,2.315 16.61,6.842 21.65,13.583 5.03,6.672 7.55,14.467 7.55,23.386 0,8.646 -1.73,16.169 -5.21,22.569 -3.4,6.4 -8.4,11.404 -15.01,15.012 -6.53,3.54 -14.46,5.311 -23.79,5.311 z m 21.65,-20.323 h 38.4 c 4.83,0 9.16,-0.919 12.97,-2.757 3.88,-1.839 6.91,-4.46 9.09,-7.864 2.25,-3.472 3.37,-7.591 3.37,-12.357 0,-4.425 -0.99,-8.408 -2.96,-11.948 -1.91,-3.608 -4.7,-6.434 -8.38,-8.476 -3.61,-2.111 -7.86,-3.166 -12.76,-3.166 H 847.2 Z m 0,-66.686 h 35.85 c 3.95,0 7.49,-0.783 10.62,-2.349 3.2,-1.634 5.72,-3.949 7.56,-6.945 1.9,-3.063 2.85,-6.74 2.85,-11.029 0,-5.719 -1.9,-10.417 -5.71,-14.093 -3.82,-3.676 -8.92,-5.515 -15.32,-5.515 H 847.2 Z",
    fill: "#d82d4f",
    id: "path49"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 752.6,266.315 c -10.96,0 -20.6,-2.383 -28.9,-7.148 -8.24,-4.834 -14.67,-11.54 -19.3,-20.119 -4.56,-8.646 -6.85,-18.654 -6.85,-30.024 0,-12.05 2.25,-22.501 6.74,-31.352 4.57,-8.85 10.9,-15.693 19,-20.527 8.1,-4.833 17.53,-7.25 28.29,-7.25 11.23,0 20.8,2.621 28.69,7.863 7.9,5.174 13.79,12.561 17.67,22.161 3.95,9.6 5.52,21.003 4.7,34.211 H 781.3 v -7.761 c -0.14,-12.8 -2.59,-22.263 -7.36,-28.39 -4.69,-6.128 -11.88,-9.191 -21.55,-9.191 -10.68,0 -18.72,3.37 -24.1,10.11 -5.37,6.74 -8.06,16.476 -8.06,29.207 0,12.119 2.69,21.514 8.06,28.186 5.38,6.604 13.14,9.906 23.29,9.906 6.67,0 12.42,-1.498 17.26,-4.494 4.9,-3.063 8.71,-7.42 11.43,-13.071 l 20.94,6.638 c -4.29,9.872 -10.79,17.531 -19.51,22.977 -8.71,5.379 -18.41,8.068 -29.1,8.068 z M 713.28,214.13 v -16.646 h 78.74 v 16.646 z",
    fill: "#d82d4f",
    id: "path50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 627.589,263.252 587.557,152.958 h 21.548 l 29.305,83.537 29.31,-83.537 h 21.55 l -40.03,110.294 z",
    fill: "#d82d4f",
    id: "path51"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m 545.758,134.883 v -20.731 h 21.344 v 20.731 z m 0,128.368 V 152.958 h 21.344 v 110.293 z",
    fill: "#d82d4f",
    id: "path52"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 438.449,263.252 V 116.194 h 21.344 v 126.939 h 66.584 v 20.119 z",
    fill: "#d82d4f",
    id: "path53"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs228"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop106"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop124"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop132"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop134"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop164"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop173"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop180"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop188"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop192"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop195"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop204"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop208"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop216"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_61_500",
    x1: 440.62701,
    y1: 676.26898,
    x2: 679.63702,
    y2: 432.52499,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-372,-371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D82D4F",
    id: "stop225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E4C18F",
    id: "stop226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E4C18F",
    id: "stop227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918269,
    stopColor: "#3ABD33",
    id: "stop228"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveBetterLogo);
export default __webpack_public_path__ + "static/media/LiveBetter_Logo.30e0b852378b4f8bf95cbbda14789c62.svg";
export { ForwardRef as ReactComponent };